function CouponExpiredCell({ isCouponActive, isCouponUpcoming }) {
  if (isCouponUpcoming) {
    return (
      <td className='px-2 md:px-6 py-3 table-cell w-1/5'>
        <div className='absolute right-4 top-1/2 -translate-y-1/2 flex items-center group-hover:invisible'>
          <div className='flex items-center justify-center bg-gray-400 rounded-md px-1.5 py-1'>
            <span className='font-medium text-sm text-white'>Upcoming</span>
          </div>
        </div>
      </td>
    )
  }

  if (!isCouponActive) {
    return (
      <td className='px-2 md:px-6 py-3 table-cell w-1/5'>
        <div className='absolute right-4 top-1/2 -translate-y-1/2 flex items-center group-hover:invisible'>
          <div className='flex items-center justify-center bg-gray-400 rounded-md px-1.5 py-1'>
            <span className='font-medium text-sm text-white'>Expired</span>
          </div>
        </div>
      </td>
    )
  }

  return null
}

export default CouponExpiredCell
